import React from "react";

// Import image
import aiPaymentIntegration from "../../assets/img/features/ai-payment-integration.png";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { Link } from "react-router-dom";

const AIPayment = () => {
  return (
    <div>
      <Header />
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div
          className="container text-center py-5"
          style={{ maxWidth: "900px" }}
        >
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            AI-Powered Secure Payment Integration for E-Commerce
          </h4>
          <ol
            className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          >
            <li className="breadcrumb-item">
              <Link to={"/"}>Home</Link>
            </li>
            <li className="breadcrumb-item active text-primary">
              AI-Powered Secure Payment
            </li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* B2B Feature Start */}
      <section className="bg-white p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-5 col-lg-5">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={aiPaymentIntegration}
                    className="img-fluid rounded w-45"
                    alt="Secure AI Payment Integration"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-7 pt-60">
              <h1>Seamless, Secure & Scalable Payment Solutions</h1>
              <p className="font-size-p">
                At Epic-X we specialize in AI-driven secure payment integration
                for eCommerce websites, ensuring fast, fraud-proof, and seamless
                transactions. Our multi-gateway payment solutions are designed
                to enhance user experience, boost conversions, and protect
                businesses from cyber threats.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* Why Choose Us Section */}
      <header className="sub-heading-section">
        <h1>Why Choose Our Secure Payment Integration Services?</h1>
      </header>
      <div className="container mt-5">
        <div className="row">
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ AI-Enhanced Fraud Detection</h5>
            <p className="font-size-p">
              Prevent chargebacks and fraudulent transactions with AI-powered
              anomaly detection.
            </p>
          </div>
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ Multi-Payment Gateway Support</h5>
            <p className="font-size-p">
              Integrate PayPal, Stripe, Razorpay, Square, Authorize.net, and
              more for global transactions.
            </p>
          </div>
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ One-Click & Express Checkout</h5>
            <p className="font-size-p">
              Reduce cart abandonment with AI-optimized checkout flows.
            </p>
          </div>
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ Seamless Cryptocurrency Payments</h5>
            <p className="font-size-p">
              Accept Bitcoin, Ethereum, and stablecoins with AI-powered
              blockchain security.
            </p>
          </div>
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ PCI-DSS & GDPR Compliance</h5>
            <p className="font-size-p">
              Ensure full compliance with the latest global payment security
              standards.
            </p>
          </div>
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ Biometric & AI-Driven Authentication</h5>
            <p className="font-size-p">
              Secure transactions with facial recognition, fingerprint scanning,
              and AI risk assessment.
            </p>
          </div>
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ Buy Now, Pay Later (BNPL) & EMI Integration</h5>
            <p className="font-size-p">
              Offer AI-powered Affirm, Klarna, Afterpay, and other flexible
              payment options.
            </p>
          </div>
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ Auto-Generated Invoicing & Tax Calculations</h5>
            <p className="font-size-p">
              AI-based invoice generation, GST/VAT calculations, and automated
              reconciliation.
            </p>
          </div>
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ AI-Powered Dispute Management</h5>
            <p className="font-size-p">
              Intelligent chargeback prevention and quick dispute resolution.
            </p>
          </div>
        </div>

        {/* Advanced Security & Compliance Section */}
        <div className="row">
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">🔒 Advanced Security & Compliance</h2>
            <ul>
              <li>
                <span className="icon-box"></span> AI-Powered Risk Analysis –
                Real-time fraud prevention using machine learning algorithms.
              </li>
              <li>
                <span className="icon-box"></span> Tokenization & End-to-End
                Encryption – Encrypt sensitive cardholder data for extra
                security.
              </li>
              <li>
                <span className="icon-box"></span> 3D Secure 2.0 & PSD2
                Compliance – Multi-factor authentication for high-risk
                transactions.
              </li>
              <li>
                <span className="icon-box"></span> AI-Based KYC & Identity
                Verification – Prevent fraud with real-time document
                verification.
              </li>
              <li>
                <span className="icon-box"></span> Automated AML (Anti-Money
                Laundering) Screening – AI-driven compliance checks for
                financial safety.
              </li>
            </ul>
          </div>
        </div>

        {/* Payment Methods Section */}
        <div className="row">
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">💳 Payment Methods We Support</h2>
            <ul>
              <li>
                <span className="icon-box"></span>{" "}
                <strong>Credit/Debit Cards:</strong> Visa, MasterCard, AmEx,
                RuPay, UnionPay
              </li>
              <li>
                <span className="icon-box"></span>{" "}
                <strong>Digital Wallets:</strong> Google Pay, Apple Pay, Samsung
                Pay, Paytm, PhonePe
              </li>
              <li>
                <span className="icon-box"></span>{" "}
                <strong>UPI & Bank Transfers:</strong> ACH, SEPA, SWIFT, UPI
              </li>
              <li>
                <span className="icon-box"></span>{" "}
                <strong>Cryptocurrency Payments:</strong> Bitcoin, Ethereum,
                USDT, Binance Pay
              </li>
              <li>
                <span className="icon-box"></span>{" "}
                <strong>Buy Now, Pay Later (BNPL):</strong> Affirm, Klarna,
                Afterpay
              </li>
            </ul>
          </div>
        </div>

        {/* Boost Conversions Section */}
        <div className="row">
          <div className="col-lg-12">
            <h2 className="section-title">
              🚀 Boost Conversions with AI-Optimized Checkout & Payments
            </h2>
            <ul>
              <li>
                <span className="icon-box"></span> AI-Based Checkout
                Optimization – Reduce drop-offs and increase conversion rates.
              </li>
              <li>
                <span className="icon-box"></span> Voice-Powered Transactions –
                Enable voice-assisted payments with AI-driven voice recognition.
              </li>
              <li>
                <span className="icon-box"></span> Personalized Payment
                Recommendations – AI suggests the best payment options based on
                user behavior.
              </li>
              <li>
                <span className="icon-box"></span> Real-Time Currency Conversion
                – AI-powered exchange rate calculations for global transactions.
              </li>
            </ul>
          </div>

          {/* Call to Action Section */}
          <section className="cta-section">
            <h2>Get Future-Ready with AI-Powered Payments!</h2>
            <p className="font-size-p">
              Secure, fast, and intelligent payment integration is key to a
              thriving eCommerce business. Let’s build a future-proof payment
              ecosystem that enhances security, user experience, and business
              growth.
            </p>
            <a href="#" className="btn-epic-x btn-primary btn-lg">
              🚀 Get Started Today!
            </a>
          </section>

          {/* Contact Information Section */}
          <div className="row g-4 mb-5">
            <div
              className="col-md-6 col-lg-3 wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <div className="contact-add-item">
                <div className="contact-icon text-primary mb-4">
                  <i className="fas fa-map-marker-alt fa-2x"></i>
                </div>
                <div>
                  <h4>Website</h4>
                  <p className="mb-0">
                    <a href="https://epic-x.io/">epic-x.io</a>
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-3 wow fadeInUp"
              data-wow-delay="0.4s"
            >
              <div className="contact-add-item">
                <div className="contact-icon text-primary mb-4">
                  <i className="fas fa-envelope fa-2x"></i>
                </div>
                <div>
                  <h4>Mail Us</h4>
                  <p className="mb-0">techsupport@epic-x.io</p>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-3 wow fadeInUp"
              data-wow-delay="0.6s"
            >
              <div className="contact-add-item">
                <div className="contact-icon text-primary mb-4">
                  <i className="fa fa-phone-alt fa-2x"></i>
                </div>
                <div>
                  <h4>Call Us</h4>
                  <p className="mb-0">+91-8925696660</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AIPayment;
